errorHandling:
  generic:
    fallback: Sorry, something went wrong. Please try again later.
    archived: The requested item is archived.
    notFound: The requested item was not found.
    unauthorised: You are not authorized to perform this action.
    validation: Validation failed. Please check and try again.
errorPage:
  gone:
    title: This page no longer exists
    defaultMessage: The page you are searching for might have been removed, had its name changed, or is temporarily unavailable. If you believe this is an error, please contact our support team for assistance.
    button:
      primary: Contact Support
      secondary: Back to Home
  notFound:
    title: Page not found
    defaultMessage: Sorry, the page you were looking for could not be found.
    button:
      primary: Contact Support
      secondary: Back to Home
  denied:
    title: Access Denied
    defaultMessage: The page you're trying to reach is restricted and it looks like you don't have permission. Get in touch with our support team to find out more.
    button:
      primary: Contact Support
      secondary: Back to Home
  deniedProject:
    title: Get access to this project
    loggedOut: Please sign in to view, or ask a team member to change the Project Access to "Anyone with the link" in the share settings
    loggedIn: Please ask a team member to update Project Access to “Anyone with the link” in the share settings.
    button:
      primary: Sign In
  crash:
    title: Something went wrong
    defaultMessage: Please try again, or get in touch with our support team if you need a hand to solve this issue.
    button:
      primary: Try Again
      secondary: Back to Home
